import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WikiPlace\GetLatLongFromAddressController::__invoke
* @see app/Http/Controllers/WikiPlace/GetLatLongFromAddressController.php
* @route '/api/place/get-lat-long-from-address'
*/
const GetLatLongFromAddressController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetLatLongFromAddressController.url(options),
    method: 'get',
})

GetLatLongFromAddressController.definition = {
    methods: ["get","head"],
    url: '/api/place/get-lat-long-from-address',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\WikiPlace\GetLatLongFromAddressController::__invoke
* @see app/Http/Controllers/WikiPlace/GetLatLongFromAddressController.php
* @route '/api/place/get-lat-long-from-address'
*/
GetLatLongFromAddressController.url = (options?: RouteQueryOptions) => {
    return GetLatLongFromAddressController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiPlace\GetLatLongFromAddressController::__invoke
* @see app/Http/Controllers/WikiPlace/GetLatLongFromAddressController.php
* @route '/api/place/get-lat-long-from-address'
*/
GetLatLongFromAddressController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetLatLongFromAddressController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WikiPlace\GetLatLongFromAddressController::__invoke
* @see app/Http/Controllers/WikiPlace/GetLatLongFromAddressController.php
* @route '/api/place/get-lat-long-from-address'
*/
GetLatLongFromAddressController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetLatLongFromAddressController.url(options),
    method: 'head',
})

export default GetLatLongFromAddressController